import React from 'react';
import styled from 'styled-components';
import { FlexRow } from './FlexRow.js';
import { Input, Select } from 'antd';

const FieldLabel = styled.div`
  display: flex;
  color: gray;
  margin-right: 10px;
  font-size: 14px;
  font-weight: 700;
  width: 300px;
  align-self: left;
`;

const SelectS = styled(Select)`
  width: 100%;
  text-align: left;
`;

export function InputField({ label, ...inputProps }) {
  return (
    <FlexRow margin="5px 0" align="center">
      <FieldLabel>{label}:</FieldLabel>
      <Input {...inputProps} />
    </FlexRow>
  );
}

export function SelectField({ label, ...selectProps }) {
  return (
    <FlexRow margin="5px 0" align="center">
      <FieldLabel>{label}:</FieldLabel>
      <SelectS {...selectProps} />
    </FlexRow>
  );
}
